import React, { useState, useEffect, useCallback } from "react";

import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";

import moment from "moment";
import { withRouter, useParams } from "react-router-dom";

import {
  getLearningEnrollments,
  editLearningEnrollmentsStatus,
  getLearningNode,
} from "../../../../services/NexiDigitalAPI";
import Loading from "../../../../components/Loading";

import PreloaderBlur from "../../PreloaderBlur";

import { Form, InputGroup, OverlayTrigger, Tooltip } from "react-bootstrap";

import ButtonWithLoading from "../../../../components/ButtonWithLoading";

import SearchIcon from "@material-ui/icons/Search";

import "./style.modules.scss";

const StatusStudents = (props) => {
  const { idTeam, nodeCode } = useParams();

  const [studentsList, setStudentsList] = useState([]);

  const [nodeInfo, setNodeInfo] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const containerStatusBase = [
    { ref: "NOT_ATTEMPTED", text: "Não iniciado" },
    { ref: "IN_PROGRESS", text: "Em andamento" },
    { ref: "COMPLETED", text: "Concluído" },
    { ref: "PASSED", text: "Aprovado" },
    { ref: "FAILED", text: "Reprovado" },
    { ref: "EXPIRED", text: "Expirado" }, /// só vai aparecer se a matricula estiver espirado
  ];

  const [pagination, setPagination] = useState({
    offset: 0,
    limit: 10,
  });

  const [totalRecords, setTotalRecords] = useState(99999);

  const [search, setSearch] = useState("");

  const paginationComponentOptions = {
    rowsPerPageText: "Usuários por página",
    rangeSeparatorText: "de",
  };

  function handleFilter() {
    const name = search ? { name: search } : {};

    setPagination({
      limit: pagination.limit,
      offset: 0,
      ...name,
    });
  }

  const onChangePage = (page) => {
    setPagination({
      ...pagination,
      offset: page === 1 ? 0 : (page - 1) * pagination.limit,
    });
  };

  const onChangeRowsPerPage = (limit, page) => {
    setPagination({
      ...pagination,
      limit,
      offset: page === 1 ? 0 : (page - 1) * limit,
    });
  };

  const setStatus = (el, status) => {
    const data = {
      idEnrollment: el.idEnrollment,
      status: status,
    };

    el.status = status;

    setIsLoaded(true);

    (async (data) => {
      await editLearningEnrollmentsStatus({ data });
      setIsLoaded(false);
    })(data);
  };

  const handleStatusFilterItens = (d) => {
    let statusContainer = containerStatusBase;

    if (d.status === "NOT_ATTEMPTED" || d.status === "IN_PROGRESS") {
      ///Se nao tiver avaliação
      if (nodeInfo?.masteryScore === null) {
        statusContainer = containerStatusBase.filter(
          (it) => it.ref !== "FAILED" && it.ref !== "PASSED" && it.ref !== "EXPIRED"
        );
      } else {
        statusContainer = containerStatusBase.filter(
          (it) => it.ref !== "COMPLETED" && it.ref !== "EXPIRED"
        );
      }
    } else {
      statusContainer = containerStatusBase.filter((it) => it.ref === d.status);
    }

    return statusContainer;
  };

  const columns = [
    {
      name: "Nome do aluno",
      selector: "name",
      sortable: true,
    },
    {
      name: "Data da Matrícula",
      selector: "enrollDate",
      sortable: true,
    },
    {
      name: "Nota",
      selector: "grade",
      sortable: true,
    },
    {
      name: "Progresso nos conteúdos",
      selector: "progress",
      sortable: true,
    },
    {
      name: "Status",
      sortable: false,
      selector: "null",
      cell: (d) => {
        const resStatusFilter = handleStatusFilterItens(d);

        return (
          <>
            {resStatusFilter.length > 1 ? (
              <InputGroup key={d.idUser}>
                <Form.Control
                  as="select"
                  value={d.status || "NOT_ATTEMPTED"}
                  onChange={(e) => setStatus(d, e.target.value)}
                >
                  {resStatusFilter.map((it, index) => (
                    <option key={`containerStatus-${index}`} value={it.ref}>
                      {it.text}
                    </option>
                  ))}
                </Form.Control>
              </InputGroup>
            ) : (
              <div>{resStatusFilter[0].text}</div>
            )}
          </>
        );
      },
      cellExport: (d) => {
        const resStatusFilter = handleStatusFilterItens(d);
        return resStatusFilter.find((x) => x.ref === d.status)?.text;
      },
    },
  ];

  const tableData = {
    columns: columns,
    data: studentsList,
  };

  const _getLearningNode = useCallback(async () => {
    const res = await getLearningNode(nodeCode, true);

    const result = res.data.result;
    setNodeInfo(result);
  }, [nodeCode]);

  const listTeams = useCallback(() => {
    setIsLoaded(true);

    getLearningEnrollments({
      offset: pagination.offset,
      limit: pagination.limit,
      name: pagination.name,
      idTeam: idTeam,
    }).then((response) => {
      const containerFilterApi = response.result.map((item) => {
        item.enrollDate = moment(item.enrollDate).utc().format("DD/MM/YYYY");
        item.progress = item.progress > 0 ? item.progress + "%" : 0;
        return item;
      });
      setTotalRecords(response.totalRecords);
      setStudentsList(containerFilterApi);

      setIsLoaded(false);
    });
  }, [idTeam, pagination]);

  useEffect(() => {
    _getLearningNode();
    listTeams();
  }, [_getLearningNode, listTeams]);

  return (
    <div className="statusStudentsBase">
      {isLoaded && <PreloaderBlur />}
      <div className="header-title-wrapper">
        <div className="header-title">
          <button
            className="btnGoBack"
            onClick={() => {
              props.history.goBack();
            }}
          >
            <KeyboardArrowLeftIcon style={{ fontSize: 40 }} />
          </button>
          Gestão de Turmas - {nodeInfo?.title && nodeInfo?.title}
        </div>
      </div>

      <div className="post-form">
        <div className="content-page-form-group">
          <div className="content-page-card">
            <div
              style={{ backgroundColor: "#6b48ff" }}
              className="card-header template-card-header"
            >
              Status dos alunos
            </div>
            <div className="card-body card-title-body template-card-body">
              <div className="containerFilter">
                <div className="containerFilterBuscar">
                  <input
                    type="text"
                    className="form-control input-default"
                    id="groupDetail"
                    style={{ marginRight: 8 }}
                    aria-describedby="usuario"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Procurar por nome"
                  />
                  <ButtonWithLoading
                    onClickHandler={handleFilter}
                    loading={isLoaded}
                    text={
                      <>
                        <SearchIcon style={{ height: 18 }} /> Pesquisar{" "}
                      </>
                    }
                    style={{ width: "100%" }}
                  />
                </div>
              </div>

              <DataTableExtensions
                filter={false}
                // filterPlaceholder={"filtro"}
                print={false}
                {...tableData}
                export={false}
              >
                <DataTable
                  columns={columns}
                  data={studentsList}
                  pagination
                  className={""}
                  progressComponent={
                    <Loading containerStyle={{ backgroundColor: "transparent" }} />
                  }
                  noHeader={true}
                  noDataComponent="Não foi encontrado nenhum dado"
                  onChangePage={onChangePage}
                  onChangeRowsPerPage={onChangeRowsPerPage}
                  paginationTotalRows={totalRecords}
                  paginationComponentOptions={paginationComponentOptions}
                  // progressPending={studentsList?.length === 0}
                  paginationServer
                  fixedHeader
                  highlightOnHover
                />
              </DataTableExtensions>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(StatusStudents);
